const archiveItems = require("./archiveItems")

const data = {
  miniLogoImage: {
    alt: "Formentera22",
    src: "/f22.png",
  },
  miniLogoOpenImage: {
    alt: "Formentera22",
    src: "/formentera20.svg",
  },
  items: [
    {
      id: "1",
      title: {
        es: "Sobre el evento",
        ca: "Sobre l'esdeveniment",
        en: "About",
      },
      anchorTo: "about",
    },
    {
      id: "2",
      title: {
        es: "Ponentes",
        ca: "Ponents",
        en: "Speakers",
      },
      anchorTo: "speakers",
    },
    {
      id: "3",
      title: {
        es: "Programa",
        ca: "Programa",
        en: "Program",
      },
      hrefTo: {
        es: "programa",
        ca: "programa-cat",
        en: "program",
      },
    },
    {
      id: "4",
      title: {
        es: "Sponsors",
        ca: "Sponsors",
        en: "Sponsors",
      },
      hrefTo: {
        es: "sponsors",
        ca: "sponsors",
        en: "sponsors",
      },
    },
    {
      id: "5",
      title: {
        es: "Archivo",
        en: "Archive",
        ca: "Arxiu",
      },
      items: archiveItems,
    },
  ],
  text1: {
    es: `Cultura digital<br>Comunicación<br>Creatividad`,
    ca: `Cultura digital<br>Comunicació<br>Creativitat`,
    en: `Digital culture<br>Communication<br>Creativity`,
  },
  textSeparatorImage: {
    src: "/wave.svg",
    alt: "",
  },
  text2: {
      es: `Del 2 al 4<br/> de octubre de 2025.`,
      ca: `Del 2 al 4<br/> d'octubre de 2025.`,
      en: `From October 2nd to 4th<br/> 2025.`,
  },
  sponsors: [
    {
      href: "#",
      image: {
        alt: "Formentera – Illes Balears",
        src: "/sponsors/formentera-black.png",
        srcblack: "/sponsors/formentera22.png",
      },
    },
    {
      href: "#",
      image: {
        alt: "Formentera – Illes Balears",
        src: "/rc.svg",
      },
    },
  ],
}
export default data
